import { render, staticRenderFns } from "./TabItineraryItem.vue?vue&type=template&id=058c2268&scoped=true&"
import script from "./TabItineraryItem.vue?vue&type=script&lang=js&"
export * from "./TabItineraryItem.vue?vue&type=script&lang=js&"
import style0 from "./TabItineraryItem.vue?vue&type=style&index=0&id=058c2268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058c2268",
  null
  
)

export default component.exports